import cn from 'classnames';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export const Card = ({ children, className }: CardProps) => {
  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-min-w-0 tw-rounded-md tw-border tw-border-[#ededed] tw-relative tw-bg-white',
        className,
      )}
    >
      {children}
    </div>
  );
};

interface CardBodyProps extends CardProps {}

export const CardBody = ({ children, className }: CardBodyProps) => {
  return (
    <div className={cn('tw-p-5 tw-flex-auto', className)}>
      {children}
    </div>
  );
};
